import type { NavGroup, NavLink, NavSectionTitle, VerticalNavItemsType } from 'src/@core/layouts/types'

export function isNavSectionTitle(item: NavLink | NavGroup | NavSectionTitle): item is NavSectionTitle {
  return 'sectionTitle' in item && Boolean((item as NavSectionTitle).sectionTitle)
}

export function isNavGroup(item: NavLink | NavGroup | NavSectionTitle): item is NavGroup {
  return 'children' in item && Boolean((item as NavGroup).children)
}

export type DrillFrame = {
  title: string
  items: VerticalNavItemsType
}

/**
 * Drops items the user cannot see; collapses groups with no visible children into a lone link when the group has `path`.
 */
export function filterSubNavTreeByAcl(
  items: VerticalNavItemsType,
  canShow: (item: NavLink) => boolean
): VerticalNavItemsType {
  const out: VerticalNavItemsType = []

  for (const raw of items) {
    if (isNavSectionTitle(raw)) continue

    if (isNavGroup(raw)) {
      const g = raw
      const filteredChildren = g.children?.length
        ? filterSubNavTreeByAcl(g.children as VerticalNavItemsType, canShow)
        : []

      if (filteredChildren.length > 0) {
        out.push({ ...g, children: filteredChildren as NavGroup['children'] })
      } else if (g.path && canShow(g as NavLink)) {
        out.push({
          title: g.title,
          path: g.path,
          icon: g.icon,
          subject: g.subject,
          action: g.action,
          auth: g.auth
        } as NavLink)
      }
    } else if (canShow(raw as NavLink)) {
      out.push(raw)
    }
  }

  return out
}
